import type { ReactNode } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

interface AccessStateNoticeProps {
    title: string;
    message: string;
    onRetry?: () => void;
    icon?: ReactNode;
    className?: string;
}

// Shared "couldn't load" panel for Access pages; also covers a 404 from
// GET /iam/users so that renders here instead of crashing the page.
export function AccessStateNotice({
    title,
    message,
    onRetry,
    icon,
    className = ''
}: AccessStateNoticeProps) {
    return (
        <div
            className={`flex-1 min-h-0 flex flex-col items-center justify-center gap-3 px-6 py-16 text-center ${className}`.trim()}
        >
            {icon ?? <ExclamationCircleIcon className="h-10 w-10 text-gray-300" strokeWidth={1} />}
            <div>
                <p className="text-sm font-semibold text-gray-700">{title}</p>
                <p className="text-sm text-gray-500 mt-1 max-w-md">{message}</p>
            </div>
            {onRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    className="text-xs text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg px-3 py-1.5 transition-colors"
                >
                    Retry
                </button>
            )}
        </div>
    );
}
